/**
 * desktopAuthHandoff.js — MASTER_PLAN §4.2, updated 2026-08-10.
 *
 * Hands the current JWT off to the Quantum Terminal desktop app, which
 * opens `/login?desktop=1&callback=http://127.0.0.1:<port>/callback` in the
 * user's real browser (not an embedded WebView — Google refuses OAuth
 * there, and Telegram's t.me deep link doesn't hand off the same way) and
 * waits on that local callback.
 *
 * Used from two places, which is exactly the bug this file fixes: AuthModal's
 * `done()` (fires right after Telegram/Google finishes) — but also needed
 * from App.jsx for a user who visits `/login?desktop=1` ALREADY signed in.
 * Before this fix only the first case existed, so the desktop app was
 * unusable without first logging out on the website and back in — `user`
 * being truthy meant App.jsx rendered MainDashboard directly and AuthModal
 * (and its handoff) never mounted at all.
 */
export function desktopAuthHandoff(token) {
  const params = new URLSearchParams(window.location.search);
  if (params.get('desktop') !== '1' || !token) return false;

  const callback = params.get('callback');
  // Whitelist: only ever a loopback URL the desktop app itself generated
  // this session. Without this check a crafted `?callback=https://evil.com`
  // link would hand a real JWT to an attacker.
  if (callback && /^http:\/\/127\.0\.0\.1:\d+\/callback$/.test(callback)) {
    window.location.href = callback + '?token=' + encodeURIComponent(token);
    return true;
  }
  // Fallback: the old embedded-WebView flow (or /login?desktop=1 opened by
  // hand, with no callback) — fragment-based, Tauri's WebView used to
  // intercept this navigation before the page even rendered.
  window.location.href = '/auth/desktop-success.html#token=' + token;
  return true;
}
